import React, { FC, MouseEvent } from 'react';
import classNames from 'classnames';

import styles from './AddToCalendar.module.scss';

interface Event {
  title?: string;
  description?: string;
  startTime?: string;
  endTime?: string;
}

interface AddToCalendarProps {
  event?: Event;
  onClickAdd?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

const AddToCalendar: FC<AddToCalendarProps> = ({ event = {}, onClickAdd = () => {} }) => {
  const formatTime = (date: string) => new Date(date).toISOString().replace(/-|:|\.\d+/g, '');

  const hrefGenerator = ({ startTime, endTime, title, description }: Event) => {
    const start = formatTime(startTime || '');
    const end = formatTime(endTime || '');

    const href = encodeURI(
      `data:text/calendar;charset=utf8,${[
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        `URL:${document.URL}`,
        `DTSTART:${start}`,
        `DTEND:${end}`,
        `SUMMARY:${title || ''}`,
        `DESCRIPTION:${description || ''}`,
        'END:VEVENT',
        'END:VCALENDAR',
      ].join('\n')}`,
    );
    return href;
  };

  return (
    <div className={classNames(styles.addToCalendar, 'quiver-add-to-calendar')}>
      <a className={styles.link} href={hrefGenerator(event)} onClick={onClickAdd}>
        Add to Calendar
      </a>
    </div>
  );
};

export default AddToCalendar;
